import React from 'react';
import $ from 'jquery';
import _ from 'lodash';
import cx from 'classnames';
import PropTypes from 'prop-types';
import ShallowRenderedComponent from '../base/ShallowRenderedComponent';
import { validateEmail } from '../../utils/forms';
import { ModalV2, ModalHeaderV2 } from '../markup/ModalV2';
import AuthDataProvider from './AuthDataProvider';

class MagicLinkModal extends ShallowRenderedComponent {

	static propTypes = {
		id: PropTypes.string
	};

	constructor(props) {
		super(props);
		this.state = {
			email: '',
			emailError: null,
			sendingEmail: false,
			showSuccessMessage: false,
			...this.state
		};
	}

	componentDidMount() {
		super.componentDidMount();
		const { id } = this.props;
		$('#' + id).on('show.bs.modal', () => {
			this.setState({email: '', emailError: null, showSuccessMessage: false, sendingEmail: false });
		});
	}

	componentWillUnmount() {
		const $modal = $('#' + this.props.id);
		$modal.off('show.bs.modal');
		$modal.modal('hide');
		super.componentWillUnmount();
	}


	onSubmitEmail = () => {
		const { email } = this.state;
		if (!validateEmail(email)) {
			this.setState({ emailError: 'Please provide a valid email' });
			return;
		}
		this.setState({ sendingEmail: true });
		this.trackPromise(AuthDataProvider.requestMagicLinkEmail(email))
			.then(() => {
				this.setState({ showSuccessMessage: true });
			})
			.catch(xhrError => {
				const error = this.getErrors(xhrError);
				this.setState({emailError: error});
				if (_.isEmpty(error)) {
					this.showErrorModal('Error while sending the link', xhrError);
				}
			})
			.finally(() => this.setState({ sendingEmail: false }));

	}

	onChange = str => {
		this.setState({email: str, emailError: null })
	};

	getErrors = (err) => {
		let error = null;
		if (err.responseStatus === 404) {
			error = 'This email was not found';
		}
		return error;
	};

	render() {
		const { email, emailError, sendingEmail, showSuccessMessage } = this.state;
		return <ModalV2 id='magic-link' noCloseOutside={true} style={{ width: '500px' }}>
			<ModalHeaderV2>
				<span className='header'>Log in with your Email</span>
				<span className='material-symbols-outlined exit-btn no-select' data-dismiss="modal" aria-hidden="true">close</span>
			</ModalHeaderV2>
			{!showSuccessMessage && <div>
				<div className='input-body'>
				<span className='description'>
					Please enter the email address for the account you want to log in as.
				</span>
				<input type='text' className={cx('email-input', {'error': !_.isEmpty(emailError)})} value={email}
					   onChange={e => this.onChange(e.currentTarget.value)}/>
				{!_.isEmpty(emailError) && <span className='email-error'>{emailError}</span>}
				</div>
					<div className='modal-controller'>
					<button className='cancel-btn' data-dismiss="modal" aria-hidden="true">Cancel</button>
					<button className='submit-btn' disabled={!_.isEmpty(emailError)}
				onClick={() => this.onSubmitEmail()}>{sendingEmail ? 'Sending...' : 'Send'}</button>
				</div>
			</div>}
			{showSuccessMessage && <div>
				<div className='input-body'>
				<span className='description'>
					An email has been sent to {email}. Please check your inbox and follow the instructions to log in.
				</span>
				</div>
				<div className='modal-controller'>
					<button className='submit-btn' data-dismiss="modal" aria-hidden="true">Close</button>
				</div>
			</div>}
		</ModalV2>;
	}

}

export default MagicLinkModal;
